module.exports = __webpack_public_path__ + "img/svg - just background.06ab1569.svg";